// 미리보기 공통 sx 토큰
// 버튼 시각은 v1 의 Joy `variant="Selection"` 이 직접 담당 (theme.ts) — 별도 sx 없음.
import { theme } from "styles/theme";

// 텍스트 입력 Sheet — 높이는 내부 textarea(자동 확장)와 padding 이 정한다 (v1 호환).
export const previewInputSheetSx = {
  backgroundColor: "#FFFFFF",
  border: `1.4px solid ${theme.vars.palette.Border.Weak}`,
  borderRadius: "6px",
  p: "12px 10px",
};

// focus 시 border 강조
export const previewInputFocusBorderColor = theme.vars.palette.Border.Highlight;
